import React from "react";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import { leasesbtn } from '../../../data/leases'
import { Col, Row, Tabs } from 'antd';

import "./Leases.css";

const LeasesRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Lease Templates", "1", "", "", "/leasing/leases/lease-templates"),
    RightBarMethod("PDF Form Templates", "2", "", "", "/leasing/leases/pdf-form-templates"),
  ]),
];

function Leases() {

  return (
    <>
    <Row>
      <Col span={24}>
        <PageHeading heading="Leases" />
      </Col>
      <Col span={24} className="leasesbtn">
        <Tabs defaultActiveKey="1" items={leasesbtn} />
      </Col>
    </Row>
    <div className="RightSidebar">
      <RightBar RightBarData={LeasesRightBar} />
    </div>
    </>
  );
}
export default Leases;
